import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarAlt, faCalendarDay, faEdit, faTools } from '@fortawesome/free-solid-svg-icons';
import Select from 'react-select';
import DatePicker from 'react-datepicker';
import { monthDayYearWithSlashFormat } from '../../../../constants/date';
import Close from '../../../common/ui/Close';
import UsersService from '../../../../services/UsersService';

export default class FilterJobs extends Component {
  render () {
    const { handleChange, start_date_from, start_date_to, invoice_date_from, invoice_date_to, skills, skillsList,
      hasEvents, companyEvents, event } = this.props;

    return (
      <Fragment>
        <div className='row align-center mb-4 mb-sm-3'>
          <label className='col-12 col-sm-3 mb-1 mb-sm-0'>
            <span className='icon-wrapper'><FontAwesomeIcon icon={faCalendarAlt} /></span>
            Start Date
          </label>
          <div className='col-12 col-sm-9 d-flex align-items-center'>
            <div className='input-picker-box'>
              <DatePicker
                className='input-picker'
                dateFormat={monthDayYearWithSlashFormat}
                onChange={val => handleChange('start_date_from', val)}
                dropdownMode={'select'}
                selected={start_date_from}
                placeholderText={'From Date'}
              />
            </div>
            <div className='input-picker-delimiter text-center'>to</div>
            <div className='input-picker-box right'>
              <DatePicker
                className='input-picker'
                dateFormat={monthDayYearWithSlashFormat}
                onChange={val => handleChange('start_date_to', val)}
                dropdownMode={'select'}
                selected={start_date_to}
                placeholderText={'Date'}
                minDate={start_date_from}
                popperPlacement='bottom-end'
              />
            </div>
          </div>
        </div>
        <div className='row align-items-center mb-4 mb-sm-3'>
          <label className='col-12 col-sm-3'>
            <span className='icon-wrapper'><FontAwesomeIcon icon={faEdit} /></span>
            Invoice Date
          </label>
          <div className='col-12 col-sm-9 d-flex align-items-center'>
            <div className='input-picker-box'>
              <DatePicker
                className='input-picker'
                dateFormat={monthDayYearWithSlashFormat}
                onChange={val => handleChange('invoice_date_from', val)}
                dropdownMode={'select'}
                selected={invoice_date_from}
                placeholderText={'From Date'}
              />
            </div>
            <div className='input-picker-delimiter text-center'>to</div>
            <div className='input-picker-box right'>
              <DatePicker
                className='input-picker'
                dateFormat={monthDayYearWithSlashFormat}
                onChange={val => handleChange('invoice_date_to', val)}
                dropdownMode={'select'}
                selected={invoice_date_to}
                placeholderText={'Date'}
                minDate={invoice_date_from}
                popperPlacement='bottom-end'
              />
            </div>
          </div>
        </div>
        <div className='row align-items-center mb-4 mb-sm-3'>
          <label className='col-12 col-sm-3'>
            <span className='icon-wrapper'><FontAwesomeIcon icon={faTools} /></span>
            Skills
          </label>
          <div className='col-12 col-sm-9'>
            <Select
              multi
              value={skills}
              onChange={val => handleChange('skills', val)}
              options={skillsList.map(skill => ({ label: skill.skill_label, value: skill.id }))}
              placeholder={'Choose Skills'}
            />
          </div>
        </div>

        {hasEvents && UsersService.isAdmin() && (
          <div className='row align-items-center mb-4 mb-sm-3'>
            <label className='col-12 col-sm-3'>
              <span className='icon-wrapper'><FontAwesomeIcon icon={faCalendarDay} /></span>
              Event
            </label>
            <div className='col-12 col-sm-9'>
              <Select
                onChange={option => handleChange('event', option)}
                options={companyEvents.map(event => ({ label: event.name, value: event.id }))}
                value={event}
                placeholder={'Enter Event Name'}
                clearRenderer={() => <Close className='button-clear' />}
              />
            </div>
          </div>
        )}
      </Fragment>
    );
  }
}

FilterJobs.propTypes = {
  hasEvents: PropTypes.bool.isRequired,
  event: PropTypes.object,
  start_date_from: PropTypes.object,
  start_date_to: PropTypes.object,
  invoice_date_from: PropTypes.object,
  invoice_date_to: PropTypes.object,
  skills: PropTypes.array.isRequired,
  skillsList: PropTypes.array.isRequired,
  companyEvents: PropTypes.array.isRequired,
  handleChange: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./src/components/common/AdvancedFilter/FilterJobs/index.js